import(/* webpackMode: "eager" */ "/app/src/app/[locale]/[...notFound]/page.tsx");
